import { UserType } from '@luminovo/api-contracts';
import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// `/` sends the user to their landing page, which checks its own access, so any signed-in user may open it.
export const Route = createFileRoute('/_authenticated/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ context: { session } }) => {
        if (session.userType === UserType.Supplier) {
            throw redirect({ to: '/supplier-portal', replace: true });
        }
        if (session.userType === UserType.Internal) {
            throw redirect({
                to: session.isFeatureFlagEnabled('luminovo_home_page') ? '/home' : '/projects',
                replace: true,
            });
        }
        // The customer portal's index route picks the customer's landing page.
        throw redirect({ to: '/customer-portal', replace: true });
    },
});
